// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { post } from '../../../common/api'
import { EMPLOYEE_REPORT, EXPENSE_REPORT, INVOICE_REPORT, LEAVE_REPORT, WORK_REPORT, ATTENDANCE_REPORT } from '../../../common/constant'

export const actionEmployeeReport = createAsyncThunk('appProject/actionEmployeeReport', async (params, thunkAPI) => {
    return await post(EMPLOYEE_REPORT, params, thunkAPI)
})

export const actionExpenseReport = createAsyncThunk('appProject/actionExpenseReport', async (params, thunkAPI) => {
    return await post(EXPENSE_REPORT, params, thunkAPI)
})

export const actionInvoiceReport = createAsyncThunk('appProject/actionInvoiceReport', async (params, thunkAPI) => {
    return await post(INVOICE_REPORT, params, thunkAPI)
})

export const actionLeaveReport = createAsyncThunk('appProject/actionLeaveReport', async (params, thunkAPI) => {
    return await post(LEAVE_REPORT, params, thunkAPI)
})

export const actionWorkReport = createAsyncThunk('appProject/actionWorkReport', async (params, thunkAPI) => {
    return await post(WORK_REPORT, params, thunkAPI)
})

export const actionAttendanceReport = createAsyncThunk('appProject/actionAttendanceReport', async (params, thunkAPI) => {
    return await post(ATTENDANCE_REPORT, params, thunkAPI)
})

export const appReportSlice = createSlice({
    name: 'appReport',
    initialState: {

        //list employee
        loadingEmployee: false,
        employee: null,

        //list expense
        loadingExpense: false,
        expense: null,

        //list invoice
        loadingInvoice: false,
        invoice: null,

        //list leave
        loadingLeave: false,
        leaveReport: null,

        //list work
        loadingWork: false,
        work: null,

        //attendance list work
        loadingAttendance: false,
        attendance: null
    },
    reducers: {
        resetEmployeeResponse: (state) => {
            state.employee = null
        },
        resetExpenseResponse: (state) => {
            state.expense = null
        },
        resetInvoiceResponse: (state) => {
            state.invoice = null
        },
        resetLeaveResponse: (state) => {
            state.leaveReport = null
        },
        resetWorkResponse: (state) => {
            state.work = null
        },
        resetAttendanceResponse: (state) => {
            state.attendance = null
        }
    },
    extraReducers: builder => {
        builder
            //employee
            .addCase(actionEmployeeReport.pending, (state) => {
                state.loadingEmployee = true
            })
            .addCase(actionEmployeeReport.fulfilled, (state, action) => {
                state.loadingEmployee = false
                state.employee = action.payload
            })
            .addCase(actionEmployeeReport.rejected, (state) => {
                state.loadingEmployee = false
            })

            //expense
            .addCase(actionExpenseReport.pending, (state) => {
                state.loadingExpense = true
            })
            .addCase(actionExpenseReport.fulfilled, (state, action) => {
                state.loadingExpense = false
                state.expense = action.payload
            })
            .addCase(actionExpenseReport.rejected, (state) => {
                state.loadingExpense = false
            })

            //invoice
            .addCase(actionInvoiceReport.pending, (state) => {
                state.loadingInvoice = true
            })
            .addCase(actionInvoiceReport.fulfilled, (state, action) => {
                state.loadingInvoice = false
                state.invoice = action.payload
            })
            .addCase(actionInvoiceReport.rejected, (state) => {
                state.loadingInvoice = false
            })

            //leave
            .addCase(actionLeaveReport.pending, (state) => {
                state.loadingLeave = true
            })
            .addCase(actionLeaveReport.fulfilled, (state, action) => {
                state.loadingLeave = false
                state.leaveReport = action.payload
            })
            .addCase(actionLeaveReport.rejected, (state) => {
                state.loadingLeave = false
            })

            //work
            .addCase(actionWorkReport.pending, (state) => {
                state.loadingWork = true
            })
            .addCase(actionWorkReport.fulfilled, (state, action) => {
                state.loadingWork = false
                state.work = action.payload
            })
            .addCase(actionWorkReport.rejected, (state) => {
                state.loadingWork = false
            })
            //attendance
            .addCase(actionAttendanceReport.pending, (state) => {
                state.loadingAttendance = true
            })
            .addCase(actionAttendanceReport.fulfilled, (state, action) => {
                state.loadingAttendance = false
                state.attendance = action.payload
            })
            .addCase(actionAttendanceReport.rejected, (state) => {
                state.loadingAttendance = false
            })
    }
})
export const { resetEmployeeResponse, resetExpenseResponse, resetInvoiceResponse, resetLeaveResponse, resetWorkResponse, resetAttendanceResponse } = appReportSlice.actions

export default appReportSlice.reducer